export default class AuditParameters {
  user_type = null;
  user_id = null;
  event = null;
  auditable_type = null;
  auditable_id = null;
  column = null;

  constructor(config = {}) {
    Object.assign(this, config);
  }

  exists(key) {
    const value = this.get(key);

    return !(value === null || value === '');
  }

  get(key) {
    if (!this.hasOwnProperty(key)) {
      return null;
    }

    return this[key] || null;
  }

  set(key, value) {
    if (this.hasOwnProperty(key)) {
      if (typeof value === 'number') {
        value = value.toString();
      }

      this[key] = value;
    }
  }

  compare(key, value) {
    return this.get(key) === value;
  }

  reset() {
    for (const key in this) {
      if (!this.hasOwnProperty(key)) {
        continue;
      }

      this[key] = null;
    }
  }

  empty() {
    for (const key in this) {
      if (!this.hasOwnProperty(key)) {
        continue;
      }

      if (this.exists(key)) {
        return false;
      }
    }

    return true;
  }
}